module.exports = __webpack_public_path__ + "img/xm.0d2b4c41.png";